import React, { PureComponent } from "react";
import { Card, CardBody, Button } from "reactstrap";
import { FileText, ExternalLink } from "lucide-react";
import Text from "../../../components/Text";
import Messages from "../../../Shared/Messages";
import "./styles.scss";

class CanvasMessage extends PureComponent {

  render() {
    const { 
      title, 
      loading, 
      onEdit, 
      messageId,
      isStreaming 
    } = this.props;

    // If still loading, show loading state
    if (loading || isStreaming) {
      return (
        <div className="canvas-message" id={`canvas-${messageId}`}>
          <Card className="canvas-card canvas-card-collapsed">
            <div className="canvas-header">
              <div className="canvas-title">
                <FileText className="canvas-icon" size={20} />
                <span>{title || "Document"}</span>
              </div>
            </div>
            <CardBody className="canvas-body">
              <div className="canvas-loading">
                <div className="loading-spinner" />
                <p>Generating document...</p>
              </div>
            </CardBody>
          </Card>
        </div>
      );
    }

    // Document is ready - show preview with open button
    return (
      <div className="canvas-message" id={`canvas-${messageId}`}>
        <Card className="canvas-card canvas-card-collapsed">
          <div className="canvas-header">
            <div className="canvas-title">
              <FileText className="canvas-icon" size={20} />
              <span>{title || "Document"}</span>
            </div>
          </div>
          
          <CardBody className="canvas-body">
            <div className="canvas-preview">
              <p className="canvas-preview-text">
                <Text content={Messages.document_generated_success} />
              </p>
              <Button
                color="primary"
                onClick={onEdit}
                className="canvas-expand-btn"
              >
                <ExternalLink size={18} />
                <span><Text content={Messages.open_document} /></span>
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default CanvasMessage;